<template>
  <div class="subpage" ref="totalRef">
    <Header v-if="$route.query.platform !== 'mini'" ref="navBarRef" title="八字命理" :is-sub-page="true"></Header>
    <cube-scroll ref="resultRef" class="result" style="flex: 1; padding: 0 15px; margin-top: 15px;">
      <section style="margin-bottom: 20px;">
        <div v-for="(item, index) in basicInfo" :key="index" class="row">
          <div class="label">{{ item.label }}</div>
          <div class="value">{{ item.value }}</div>
        </div>
      </section>

      <section>
        <div style="padding-bottom: 20px; border-bottom: 1px solid #DDDDDD">
          <div v-for="(row, index) in siZhuInfo" :key="'i_' + index" class="row">
            <div v-for="(item, cId) in row" :key="'c_' + cId" style="flex: 1" :class="[item.highlight ? 'highlight' : '']">
              <template v-if="index === 3">
                <template v-if="cId !== 0">
                  <div v-for="i of item.value.length" :key="i">
                    {{ item.value[i - 1] }}
                  </div>
                </template>
                <div v-else>
                  {{ item.value }}
                </div>
              </template>
              <div v-else>
                {{ item.value }}
              </div>
            </div>
          </div>
        </div>

        <div style="padding: 20px 10px 0 10px">
          <div class="row" style="margin-bottom: 15px;">
            <div
              v-for="(item, index) of dayunInfo"
              :key="'dayun_' + index"
              :style="[index === 0 ? { width: '20%', textAlign: 'left' } : { flex: '1' }]">
              <div v-for="i of item.length" :key="i">
                {{ item[i - 1] }}
              </div>
            </div>
          </div>

          <div
            v-for="(item, index) of liuyiInfo"
            :key="'liuyi_' + index"
            class="row"
            style="text-align: left">
            <div>{{ item.label }}：</div>
            <div>
              <div v-for="i of item.value.length" :key="i">
                {{ item.value[i - 1] }}
              </div>
            </div>
          </div>
        </div>
      </section>
    </cube-scroll>
  </div>
</template>

<script>
import Header from '@/components/Header'

import { testSiZhu } from '@/api/test'

export default {
  name: 'Result',
  components: {
    Header
  },
  data () {
    return {
      formData: null,
      basicInfo: null,
      siZhuInfo: null,
      dayunInfo: null,
      liuyiInfo: null
    }
  },
  mounted () {
    this.formData = JSON.parse(this.$route.query.data)
    console.log(this.formData)
    this.getResult()
  },
  methods: {
    getResult () {
      testSiZhu({
        birthday: this.formData.birthday.replace('年', '-')
          .replace('月', '-')
          .replace('日', '')
          .replace('时', ''),
        birthdayType: this.formData.birthdayType === '阳历' ? '0' : '1',
        gender: this.formData.gender === '男' ? '0' : '1'
      }).then(res => {
        console.log(res)
        const result = res.data
        this.basicInfo = [
          { label: '姓名:', value: this.formData.name || '未填写' },
          { label: '性别:', value: this.formData.gender },
          { label: '出生地:', value: this.formData.birthCity.length > 0 ? this.formData.birthCity.join(' ') : '未填写' },
          { label: '出生阳历:', value: result.gregorianCalendar },
          { label: '出生阴历:', value: result.lunarCalendar }
        ]
        this.siZhuInfo = [
          res.data.tenGods.map(item => { return { value: item } }),
          [{ value: '天干' }, ...res.data.tianGan.map(item => { return { value: item, highlight: true } })],
          [{ value: '地支' }, ...res.data.diZhi.map(item => { return { value: item, highlight: true } })],
          [{ value: '藏干' }, ...res.data.zangGan.map(item => { return { value: item } })]
        ]

        this.dayunInfo = ['大运', ...res.data.daYun]
        console.log(this.dayunInfo)
        this.liuyiInfo = [
          { label: '天干留意', value: res.data.tianGanAttention },
          { label: '地支留意', value: res.data.diZhiAttention }
        ]

        console.log(this.siZhuInfo)
      })
    }
  }
}
</script>

<style lang="stylus" scoped src="@/style/form.styl"></style>
<style lang="stylus" scoped>
.subpage
  background url("~@/assets/images/backgrounds/bg.png") no-repeat center
  background-size 100% 100%

.result
  section
    background #ffffff
    padding 20px
    font-size 15px
    color #545454
    .row
      line-height 30px
      display flex
      .label
        width 75px
        text-align left
      .highlight
        color #874DD5
        font-size 20px
        line-height 35px
</style>

<style lang="stylus">
body
  background-color #EFE9E0
</style>
